import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class UpdateSpinWheelUserEntity {
  users?: UserMiniEntity[]
}
